import React from 'react'
import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded'
import { NavLink } from 'react-router-dom'
import { AnimatedSection, AnimatedValue, metricMotion } from '../animations/MotionContainers'

const MetricSurface = ({ path, children, className }) => (
  path
    ? <CardActionArea component={NavLink} to={path} className={className}>{children}</CardActionArea>
    : <Box className={className}>{children}</Box>
)

export const MetricCard = ({ title, value, action, icon, path }) => (
  <AnimatedSection variant={metricMotion}>
    <Card className="metric-card">
      <MetricSurface
        path={path}
        className="metric-card-action"
      >
        <CardContent className="metric-card-content">
          <Box className="metric-icon">{icon}</Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography className="metric-title">{title}</Typography>
            <Typography className="metric-value" component="div">
              <AnimatedValue value={value}>{value}</AnimatedValue>
            </Typography>
          </Box>
          {action && (
            <Box className="metric-action">
              <Typography>{action}</Typography>
              <ArrowForwardRoundedIcon sx={{ fontSize: 18 }} />
            </Box>
          )}
        </CardContent>
      </MetricSurface>
    </Card>
  </AnimatedSection>
)
